import script from "./RequestInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestInfo.vue?vue&type=script&setup=true&lang=js"

import "./RequestInfo.vue?vue&type=style&index=0&id=fb8a689a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb8a689a"]])

export default __exports__